import React from 'react';
import { Button, Menu, Dropdown, Icon } from 'antd';

import { hasAuth } from "../../../utils/NHCore";
import getSize from '../../../utils/getSize';
import NHTable from '../../common/NHTable';


import css from './index.css';


/**
 * 宿舍住宿信息查询
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-08-21 
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('宿舍住宿信息');
    }

    render() {

        const columns = [
            {
                title: '序号',
                width: '50px',
                dataIndex: 'ROW_ID',
            }, {
                title: '校区',
                width: '120px',
                dataIndex: 'XQMC',
                searchType:"select"
            }, {
                title: '楼栋',
                width: '120px',
                dataIndex: 'LDMC',
                searchType:"input"
            }, {
                title: '楼层',
                width: '120px',
                dataIndex: 'LCMC',
                searchType:"select"
            }, {
                title: '房间',
                width: '120px',
                dataIndex: 'FJMC',
                searchType:"input"
            }, {
                title: '男女属性',
                width: '100px',
                dataIndex: 'NVSXMC',
                searchType:"select"
            }, {
                title: '收费标准',
                width: '100px',
                dataIndex: 'SFBZ',
                searchType:"input"
            }, {
                title: '床位',
                width: '80px',
                dataIndex: 'CWH',
                searchType:"select"
            },{
                title: '年级',
                width: '80px',
                dataIndex: 'NJ',
                searchType:"select"
            }, {
                title: '学院',
                width: '150px',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '150px',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                width: '150px',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '学号',
                width: '120px',
                dataIndex: 'XH',
                searchType:"input"
            }, {
                title: '姓名',
                width: '100px',
                dataIndex: 'XM',
                searchType:"input"
            }, {
                title: '性别',
                width: '80px',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '电话',
                width: '80px',
                dataIndex: 'SJHM'
            }, {
                title: '入住状态',
                width: '100px',
                dataIndex: 'RZZT',
                searchType:"select"
            }, {
                title: '入住方式',
                width: '100px',
                dataIndex: 'RZFS',
                searchType:"input"
            }, {
                title: '入住时间',
                width: '100px',
                dataIndex: 'RZSJ',
                searchType:"date"
            }, {
                title: '是否空床位',
                width: '120px',
                dataIndex: 'SFKCW',
                searchType:"select"
            }
        ];

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div style={{ width: '100%', height: '100%' }}>
                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_gyxt_tjcx_sszsxxcx"}
                        columns={columns}
                    >
                        {hasAuth('zhxg_yxgl_tjcx_sszsxxcx:export')?<Button type="primary" ghost style={{marginLeft:10}} onClick={this.handleOtpBtnClick}>导出</Button>:undefined}
                    </NHTable>
                </div>
            </div>
        )
    }

}

export default IndexComponent;


// WEBPACK FOOTER //
// ./components/tjcx/sszsxxcx/index.js